/**
 * One window event after any successful DEC5 write, so every pending-count
 * badge (nav row, Settings tab) refetches instead of lagging the panel.
 *
 * @module services/targets/targetsEvents
 */
export const TARGETS_CHANGED = 'targets:changed';

export const announceTargetsChanged = (): void => {
  window.dispatchEvent(new Event(TARGETS_CHANGED));
};
